import React, { useRef } from "react";
import { Navigate } from "react-router-dom";
import { createGlobalStyle } from 'styled-components';
import axios from 'axios';
import styled from 'styled-components';
import { getUser, setUser } from 'helpers/user';
import { assets } from 'helpers/generic';

const GlobalStyle = createGlobalStyle`
	html, body {
		height: 100%;
		background-color: #182627;
	}

	#background {
		position: fixed;
		background-size: cover !important;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		background: url(${assets('/img/login_background.webp')});
		background-repeat: no-repeat;
		background-position: right;
		background-size: 100%;
		display: flex;
	}

	.logo {
		text-align: center;

		.img-wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;

			img {
				filter: brightness(0) invert(1);

				&:first-of-type {
					width: 120px;
					height: 120px;
					margin-bottom: 20px;
				}

				&:last-of-type {
					width: 240px;
				}
			}
		}

		.text {
			font-weight: bold;
			font-size: 40px;
			color: white;
		}
	}

	.card {
		border: none;
		background: transparent;

		.card-body {
			padding: 0px;
			width: max-content;
			overflow: hidden;
			border-radius: 25px;
			background: var(--plenoil-blue);
			border: 1px solid var(--plenoil-blue-light);

			.login-header {
				display: flex;
				justify-content: center;
				position: relative;
				background-size: cover;
				height: 100px;

				h3 {
					position: absolute;
					color: var(--plenoil-yellow);
					text-align: center;
					margin: 0;
					padding: 0;
					font-size: 22px;
					font-weight: bold;
					top: 30px;
				}
			}

			.login-form {
				padding: 20px;

				.login-input {
					position: relative;
					border-bottom: 1px solid var(--plenoil-blue-light);
					margin-bottom: 15px;

					.login-input-img-wrapper {
						display: flex;
						align-items: center;
						position: absolute;
						width: 14px;
						height: 100%;

						.login-input-img {
							width: 100%;
							opacity: 0.3;
						}
					}
					
					input {
						color: white;
						border: none;
						background: transparent;
						width: 100%;
						font-size: 16px;
						letter-spacing: -0.5px;
						padding: 3px 10px;
						padding-left: 25px;

						&:focus {
							outline: none;
						}

						&::placeholder {
						  color: white;
						  opacity: 1;
						}

						&:-ms-input-placeholder {
						  color: white;
						}

						&::-ms-input-placeholder {
						  color: white;
						}
					}
				}

				button {
					background: var(--plenoil-orange);
					color: var(--plenoil-white);
					display: block;
					width: 100%;
					padding: 8px;
					border-radius: 30px;
					border: 0;
					margin-top: 20px;
					user-select: none;
					font-size: 15px;
				}

				.login-error {
					color: var(--plenoil-white);
					background: var(--plenoil-red);
					padding: 10px;
					border-radius: 30px;
					text-align: center;
					margin-top: 10px;
					font-size: 12px;
				}

				}
				
				label {
					color: var(--plenoil-yellow);
					}
					
					input {
						background: var(--plenoil-white);
						}
						}
						}
	.logo-login {
		margin-bottom: 18px;
	}

	.form-group {
		margin-bottom: 1rem;
	}

	.form-text {
		display: block;
		margin-top: .25rem;
	}

	.pt10 {
		padding-top: 10px !important;
	}
`;

export default function Login() {
	// Refs
	const usernameRef = useRef(null);
	const passwordRef = useRef(null);

	const login = (e) => {
		e.preventDefault();

		axios.post('api/login', {
			username: usernameRef.current.value,
			password: passwordRef.current.value
		})
		.then((response) => {
			setUser(response.data.user);
			window.location.reload();
		});	

	};

	if ( getUser() ) return <Navigate to="/" />;

	// Render
	return (
		<React.Fragment>
			<div id="background">
				<GlobalStyle />
				<div className="background-color-login row mx-auto w300 align-self-center">
					<div className="col">
						<div className="text-center py-3">
							<div className="login-form">
								<img src={assets('/img/logo-plenergy-login.webp')} className="w200 pb-1 pt-5 logo-login" alt="Logo" />
								<form action="">
									<div className="form-group">
										<input ref={usernameRef} placeholder="Escribe tu email" className="form-control control-input" type="text" />
										{/* <div className="label-message-error"><span className="field-validation-valid"></span></div> */}
									</div>
									<div className="form-group pt10">
										<input ref={passwordRef} placeholder="Escribe tu contraseña" className="form-control control-input cursor-text password-input" type="password" />
										{/* <div className="label-message-error"><span className="field-validation-valid"></span></div> */}
										{/* <small className="form-text text-white pt10">¿Olvidaste la contraseña? <a id="forgot-password" href="/Identity/Account/ForgotPassword">Picha aquí</a></small> */}
									</div>
									<div className="py-3">
										<button onClick={(e) => login(e)} className="btn btn-naranja-plenoil">Iniciar sesión</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}